module.exports = __webpack_public_path__ + "img/zhigongxiaojia.f3c1ef6e.png";